<template>
  <div
    v-if="noSubscription && freePlan && !isBacker"
    class="text-center"
  >
    <site-link
      :to="{ name: routerLinkName }"
      class="button primary"
    >
      Start for Free
      <font-awesome-icon
        :icon="$v7.solid.faRocketLaunch"
        size="lg"
        class="margin-left-sm"
      />
    </site-link>
  </div>

  <div
    v-else-if="isReactivation && 'Free' !== planName"
    class="text-center"
  >
    <site-link
      :to="{ name: routerLinkName }"
      class="button accent"
    >
      <font-awesome-icon
        :icon="$v7.solid.faRocketLaunch"
        size="lg"
        class="margin-right-sm"
      />
      Get a New Plan!
    </site-link>
  </div>

  <div
    v-else-if="noSubscription && isBacker"
    class="text-center"
  >
    <site-link
      :to="{ name: routerLinkName }"
      class="button accent"
    >
      Start a Subscription
      <font-awesome-icon
        :icon="$v7.solid.faRedo"
        size="lg"
        class="margin-left-sm"
      />
    </site-link>
    <p>and continue using services!</p>
  </div>

  <div
    v-else-if="noSubscription && paidPlan"
    class="text-center"
  >
    <site-link
      :to="{ name: routerLinkName }"
      class="button"
    >
      Get More with {{ planName }}
      <font-awesome-icon
        :icon="$v7.solid.faRocketLaunch"
        size="lg"
        class="margin-left-sm"
      />
    </site-link>
  </div>

  <div
    v-else-if="upgradeFromFreeToPro"
    class="text-center"
  >
    <site-link
      :to="{ name: routerLinkName }"
      class="button"
    >
      Upgrade to a Pro Plan
      <font-awesome-icon
        :icon="$v7.solid.faArrowUp"
        size="lg"
        class="margin-left-sm"
      />
    </site-link>
    <p>to get more icons, styles, and services!</p>
  </div>

  <div
    v-else-if="isUpgrade && !isLegacySubscription"
    class="text-center"
  >
    <site-link
      :to="{ name: routerLinkName }"
      class="button"
    >
      Upgrade to This Plan
      <font-awesome-icon
        :icon="$v7.solid.faArrowUp"
        size="lg"
        class="margin-left-sm"
      />
    </site-link>
    <p>to get more icons, styles, and services!</p>
  </div>
</template>

<script>
  import { get, startsWith } from 'lodash'
  import accounting from 'accounting'

  export default {
    name: 'PlanChange',

    props: {
      plan: {
        type: Object
      },

      subscription: {
        type: Object
      },

      determinations: {
        type: Object
      },

      isCurrentPlan: {
        type: Boolean
      },

      discount: {
        type: Number
      },

      priceWithDiscount: {
        type: Number
      },

      colorSet: {
        type: Object,
        required: true
      }
    },

    computed: {
      planName() {
        return get(this.plan, ['name']) || get(this.subscription, ['plan', 'name'])
      },

      noSubscription() {
        return !this.subscription
      },

      planPrice() {
        const plan = this.plan || get(this.subscription, ['plan'])

        return get(plan, ['price', 'amount'], 0)
      },

      freePlan() {
        return this.planPrice === 0
      },

      paidPlan() {
        return !this.freePlan
      },

      isBacker() {
        return this.determinations.isBacker
      },

      routerLinkName() {
        const plan = this.plan || get(this.subscription, ['plan'])
        const sku = get(plan, ['sku'])

        let val = 'plans'

        if (sku === 'FA-FREE' && !this.subscription) {
          val = 'start'
        }

        if (sku === 'FA-FREE' && this.subscription) {
          val = 'plans'
        }

        if (this.isReactivation) {
          val = 'plans'
        }

        if (this.isBacker) {
          val = 'plans'
        }

        return val
      },

      amounts() {
        return {
          subscription: get(this, ['subscription', 'total', 'amount'], 0),
          plan: get(this, ['plan', 'price', 'amount'], 0)
        }
      },

      totalTodayFormatted() {
        const val = this.priceWithDiscount || this.amounts.subscription - (this.discount || 0)

        return accounting.formatMoney(val / 100, { precision: 0 })
      },

      isReactivation() {
        return this.subscription && !!this.subscription.endedAt
      },

      isLegacySubscription() {
        return startsWith(get(this, ['subscription', 'plan', 'sku']), 'PRO1Y')
      },

      upgradeFromFreeToPro() {
        const { plan, subscription } = this.amounts

        return plan === subscription && subscription === 0
      },

      isUpgrade() {
        const { plan, subscription } = this.amounts

        return !this.isCurrentPlan && plan > subscription
      },

      isDowngrade() {
        const { plan, subscription } = this.amounts

        return !this.isCurrentPlan && plan < subscription
      }
    }
  }
</script>
